import Slider from "../components/sidebar";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetcDeliveryTime } from "../services/DeliveryTime";
import { updatesaleorder,API_FetchSelectSettingsNew, fetchSelectDriver } from '../services/Order';


const OrderEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [orderDetails, setOrderDetails] = useState(null);
  const [deliverytime, setDeliverytime] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [adminId, setAdminId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedDeliveryTime, setSelectedDeliveryTime] = useState("");
  const [selectedDriver, setSelectedDriver] = useState("");
  const [status, setStatus] = useState("0");
  const [deliverydate, setDeliverydate] = useState("");
  const [, setwhatsapdata] = useState([]);

  const formatDateForInput = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toISOString().split('T')[0];
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const adminUserId = JSON.parse(localStorage.getItem("adminuserid"));
    if (!adminUserId) {
      alert("Session Closed. Please Login Again!");
      setTimeout(() => navigate("/"), 2000);
    } else {
      setAdminId(Number(adminUserId));
    }
  }, [navigate]);

  useEffect(() => {
    const orderData = JSON.parse(localStorage.getItem("ordereditdetails"));
    if (orderData) {
      const selectedOrder = orderData.find((order) => order.Id === parseInt(id, 10));
      if (selectedOrder) {
        setOrderDetails(selectedOrder);
        
        // Initialize form controls from the existing order
        if (selectedOrder.DriverId) setSelectedDriver(selectedOrder.DriverId.toString());
        if (selectedOrder.DeliveryDate) setDeliverydate(formatDateForInput(selectedOrder.DeliveryDate));
        if (selectedOrder.DeliveryTime) setSelectedDeliveryTime(selectedOrder.DeliveryTime.toString());
        
        // Try mapping status if it exists
        if (selectedOrder.Status !== undefined) setStatus(selectedOrder.Status.toString());
        else if (selectedOrder.orderstatus) {
            const statusMap = { 'Pending': '0', 'Cancelled': '-1', 'Accepted': '1', 'Delivered': '2' };
            setStatus(statusMap[selectedOrder.orderstatus] || '0');
        }

        console.log(selectedOrder);
      } else {
        navigate("/Admin/OrderPanel");
      }
    } else {
      navigate("/Admin/OrderPanel");
    }
  }, [id, navigate]);

  useEffect(() => {
    if (adminId) {
      fetchDeliveryTimeData();
      fetchDriversData();
      FetchSelectSettingsNew();
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId]);


  const FetchSelectSettingsNew = async () => {
    try {
        const list = await API_FetchSelectSettingsNew(adminId);
  

        if (Array.isArray(list) && list.length > 0) {
            setwhatsapdata(list); 
        } else {
            console.error("Fetched data is not a valid array or is empty.");
            setwhatsapdata([]); 
        }
    } catch (error) {
        setwhatsapdata([]);
        console.error("Error fetching categories:", error);
    }
};


useEffect(() => {
  // We handle initial fetch in the adminId useEffect now
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);





  const fetchDeliveryTimeData = async () => {
    try {
      const data = await fetcDeliveryTime(adminId);
      console.log(data)
      setDeliverytime(data || []);
    } catch (err) {
      console.error("Error fetching delivery time data: " + err.message);
    }
  };

  const fetchDriversData = async () => {
    try {
      const data = await fetchSelectDriver(adminId);
      setDrivers(data || []);
    } catch (err) {
      console.error("Error fetching drivers: " + err.message);
    }
  };



   





  const downloadInvoicePDF = () => {
    if (!orderDetails) return;

    const {
      OrderNo,
      OrderDate,
      DeliveryType,
      OrderType,
      Grossamt,
      DeliveryFees,
      CouponDiscount,
      WalletAmount,
      CustomerName,
      Address1,
      Address2,
      City,
      Pincode,
      MobileNo,
      OrderDetails,
    } = orderDetails;

    const totalAmount = (
      Number(Grossamt || 0) +
      Number(DeliveryFees || 0) - 
      Number(CouponDiscount || 0) - 
      Number(WalletAmount || 0)
    ).toFixed(2);

    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Invoice - ${OrderNo}</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
            
            body { 
              font-family: 'Inter', Arial, sans-serif; 
              line-height: 1.5; 
              color: #111; 
              background: #fff;
              padding: 0;
              margin: 0;
            }
            .invoice-container {
              max-width: 21cm;
              margin: 0 auto;
              padding: 40px;
              background: #fff;
            }
            .header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border-bottom: 2px solid #222;
              padding-bottom: 20px;
              margin-bottom: 30px;
            }
            .company-info h1 {
              font-size: 28px;
              font-weight: 700;
              margin: 0 0 5px 0;
              text-transform: uppercase;
              letter-spacing: 1px;
            }
            .company-info p {
              margin: 0;
              color: #555;
              font-size: 14px;
            }
            .invoice-title {
              text-align: right;
            }
            .invoice-title h2 {
              font-size: 24px;
              font-weight: 600;
              margin: 0 0 5px 0;
              color: #222;
            }
            .invoice-title p {
              margin: 0;
              font-size: 14px;
              color: #555;
            }
            
            .meta-section {
              display: flex;
              justify-content: space-between;
              margin-bottom: 30px;
            }
            .address-block {
              flex: 1;
            }
            .address-block h3 {
              font-size: 14px;
              font-weight: 700;
              text-transform: uppercase;
              color: #555;
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
              margin-bottom: 10px;
            }
            .address-block p {
              margin: 2px 0;
              font-size: 14px;
            }
            
            .order-details-block {
              flex: 1;
              text-align: right;
            }
            .order-details-block table {
              width: 100%;
              max-width: 300px;
              float: right;
              border-collapse: collapse;
            }
            .order-details-block th, .order-details-block td {
              padding: 4px 0;
              font-size: 14px;
              text-align: right;
            }
            .order-details-block th {
              color: #555;
              font-weight: 600;
              padding-right: 15px;
            }
            
            .items-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            .items-table th {
              background-color: #f8f8f8;
              color: #333;
              font-weight: 600;
              text-transform: uppercase;
              font-size: 12px;
              padding: 12px;
              text-align: left;
              border-bottom: 2px solid #222;
            }
            .items-table td {
              padding: 12px;
              font-size: 14px;
              border-bottom: 1px solid #eee;
            }
            .items-table th.right-align, .items-table td.right-align {
              text-align: right;
            }
            .items-table th.center-align, .items-table td.center-align {
              text-align: center;
            }
            
            .summary-section {
              display: flex;
              justify-content: flex-end;
              margin-top: 20px;
            }
            .summary-table {
              width: 350px;
              border-collapse: collapse;
            }
            .summary-table td {
              padding: 8px 12px;
              font-size: 14px;
            }
            .summary-table td:first-child {
              text-align: right;
              color: #555;
            }
            .summary-table td:last-child {
              text-align: right;
              font-weight: 500;
            }
            .summary-table tr.total td {
              border-top: 2px solid #222;
              font-weight: 700;
              font-size: 18px;
              padding-top: 15px;
            }
            
            .footer {
              margin-top: 50px;
              padding-top: 20px;
              border-top: 1px solid #ddd;
              text-align: center;
              font-size: 12px;
              color: #777;
            }
            
            @media print {
              body { background: #fff; }
              .invoice-container { box-shadow: none; padding: 0; max-width: 100%; }
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            <!-- Header -->
            <div class="header">
              <div class="company-info">
                <h1> Invoice</h1>
                <p>Original for Recipient</p>
              </div>
              <div class="invoice-title">
                <h2>Order #${OrderNo}</h2>
                <p>Date: ${new Date(OrderDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
              </div>
            </div>
            
            <!-- Meta Section -->
            <div class="meta-section">
              <div class="address-block" style="margin-right: 40px;">
                <h3>Billed To</h3>
                <p style="font-weight: 600; color: #111;">${CustomerName || '--'}</p>
                <p>${[Address1, Address2].filter(Boolean).join(', ') || '--'}</p>
                <p>${[City, Pincode].filter(Boolean).join(' - ') || '--'}</p>
                <p style="margin-top: 5px;"><strong>Phone:</strong> ${MobileNo || '--'}</p>
              </div>
              
              <div class="order-details-block">
                <table>
                  <tr>
                    <th>Payment Method:</th>
                    <td>${OrderType || '--'}</td>
                  </tr>
                  <tr>
                    <th>Delivery Type:</th>
                    <td>${DeliveryType || '--'}</td>
                  </tr>
                </table>
              </div>
            </div>
            
            <!-- Items Table -->
            <table class="items-table">
              <thead>
                <tr>
                  <th style="width: 5%;">#</th>
                  <th style="width: 45%;">Item Description</th>
                  <th class="right-align" style="width: 15%;">Unit Price</th>
                  <th class="center-align" style="width: 15%;">Qty</th>
                  <th class="right-align" style="width: 20%;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${OrderDetails && OrderDetails.length > 0 ? OrderDetails.map((item, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td style="font-weight: 500;">${item.ProductName}</td>
                    <td class="right-align">₹${Number(item.SaleRate).toFixed(2)}</td>
                    <td class="center-align">${item.ItemQty}</td>
                    <td class="right-align" style="font-weight: 500;">₹${(Number(item.SaleRate) * Number(item.ItemQty)).toFixed(2)}</td>
                  </tr>
                `).join('') : '<tr><td colspan="5" style="text-align: center; color: #999; padding: 40px;">No items found</td></tr>'}
              </tbody>
            </table>
            
            <!-- Summary -->
            <div class="summary-section">
              <table class="summary-table">
                <tr>
                  <td>Subtotal:</td>
                  <td>₹${Number(Grossamt || 0).toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Delivery Charges:</td>
                  <td>₹${Number(DeliveryFees || 0).toFixed(2)}</td>
                </tr>
                ${Number(CouponDiscount) > 0 ? `
                <tr>
                  <td>Discount:</td>
                  <td style="color: #d9534f;">-₹${Number(CouponDiscount || 0).toFixed(2)}</td>
                </tr>
                ` : ''}
                ${Number(WalletAmount) > 0 ? `
                <tr>
                  <td>Wallet Used:</td>
                  <td style="color: #d9534f;">-₹${Number(WalletAmount || 0).toFixed(2)}</td>
                </tr>
                ` : ''}
                <tr class="total">
                  <td>Grand Total:</td>
                  <td>₹${totalAmount}</td>
                </tr>
              </table>
            </div>
            
            <!-- Footer -->
            <div class="footer">
              <p>Thank you for shopping with us!</p>
              <p>This is a computer generated invoice and requires no signature.</p>
            </div>
          </div>
        </body>
      </html>
    `;
    
    const printWindow = window.open('', '_self');
    if (!printWindow) {
      alert('Unable to access the current window for printing. Please try again.');
      return;
    }

    printWindow.document.write(printContent);
    printWindow.document.close();

    const handlePrint = () => {
      printWindow.focus();
      printWindow.print();
    };

    setTimeout(handlePrint, 300);

    window.onafterprint = () => {
      window.location.reload();
    };
  };

  const handleSave = async () => {
    setLoading(true);
    const Pid = parseInt(id);
    const DD1 = selectedDeliveryTime;
    const DD = deliverydate;
    const userMobileNo = orderDetails?.MobileNo || "";
    const driverId = parseInt(selectedDriver) || 0;
    // eslint-disable-next-line no-unused-vars
     const objlist = {
      temp: status,
      deliveryTime: selectedDeliveryTime,
      deliverydate: deliverydate,
      driverId: driverId,
    };

    try {
      // Fetch directly to get the current list instead of relying on state closure
      const list = await API_FetchSelectSettingsNew(adminId);
      if (Array.isArray(list) && list.length > 0) {
        const { WhatsAppUrl, OwnerMobileNo } = list[0]; 

        const success = await updatesaleorder(adminId, Pid, status, DD, DD1, WhatsAppUrl, OwnerMobileNo, userMobileNo, driverId);
        if (success) {
          alert("Order updated successfully!");
          navigate(`/Order`);
        } else {
          setErrorMessage("Failed to update the order.");
        }
      } else {
        setErrorMessage("WhatsApp settings not found. Cannot save order.");
      }
    } catch (error) {
      console.error("Error during order update:", error);
      setErrorMessage("An error occurred while updating the order.");
    } finally {
      setLoading(false);
    } 
  };

  if (!orderDetails) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <p>Loading...</p>
      </div>
    );
  }

  const {
    OrderNo,
    OrderDate,
    DeliveryType,
    OrderType,
    Grossamt,
    DeliveryFees,
    CouponDiscount,
    WalletAmount,
    CustomerName,
    DeliveryDate: OrderDeliveryDate,
    Address1,
    Address2,
    City,
    Pincode,
    MobileNo,
    OrderDetails,
  } = orderDetails;

  const totalAmount = (
    Number(Grossamt || 0) +
    Number(DeliveryFees || 0) - 
    Number(CouponDiscount || 0) - 
    Number(WalletAmount || 0)
  ).toFixed(2);

  return (
    <div className="flex h-screen bg-slate-50">
      <div className="hidden xl:block xl:w-72 flex-shrink-0">
        <Slider />
      </div>
      <div className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
        <div className="mx-auto max-w-6xl space-y-6">
          {/* Professional Header Section */}
          <section className="rounded-2xl bg-white border border-slate-200 p-8 shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-slate-900">Order Invoice #{OrderNo}</h1>
                <p className="text-sm text-slate-500 mt-2">Order Date: {new Date(OrderDate).toLocaleDateString()}</p>
              </div>
              <div className="text-right bg-slate-50 rounded-xl px-6 py-4 border border-slate-200">
                <p className="text-xs uppercase tracking-widest text-slate-600 font-semibold mb-1">Total Amount</p>
                <p className="text-3xl font-bold text-slate-900">₹{totalAmount}</p>
              </div>
            </div>
          </section>

          {/* Invoice Details Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Order Info Card */}
            <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-md hover:shadow-lg transition-shadow">
              <h2 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
                  <span className="text-slate-700 font-bold">ℹ️</span>
                </div>
                Order Information
              </h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Delivery Type</span>
                  <span className="text-sm font-bold text-slate-900">{DeliveryType || "--"}</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Payment Type</span>
                  <span className="text-sm font-bold text-slate-900">{OrderType || "--"}</span>
                </div>
              </div>
            </section>

            {/* Customer Info Card */}
            <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-md hover:shadow-lg transition-shadow">
              <h2 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
                  <span className="text-slate-700 font-bold">👤</span>
                </div>
                Customer Details
              </h2>
              <div className="space-y-4">
                <div className="p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Name</span>
                  <p className="text-sm font-bold text-slate-900 mt-1">{CustomerName || "--"}</p>
                </div>
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Mobile</span>
                  <span className="text-sm font-bold text-slate-900">{MobileNo || "--"}</span>
                </div>
                <div className="p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Address</span>
                  <p className="text-sm font-bold text-slate-900 mt-1">{`${Address1 || ""}, ${Address2 || ""}, ${City || ""}, ${Pincode || ""}`}</p>
                </div>
              </div>
            </section>
          </div>

          {/* Order Items Table */}
          <section className="rounded-2xl border border-slate-200 bg-white shadow-md overflow-hidden">
            <div className="p-6 border-b border-slate-200 bg-slate-50">
              <h2 className="text-lg font-bold text-slate-900 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-200 flex items-center justify-center">
                  <span className="text-slate-700 font-bold">📦</span>
                </div>
                Order Items
              </h2>
            </div>
            <div className="overflow-x-auto">
              {OrderDetails && OrderDetails.length > 0 ? (
                <table className="w-full">
                  <thead>
                    <tr className="bg-slate-50 border-b border-slate-200">
                      <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">S.No</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">Product Name</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">MRP</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">Unit Price</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-slate-900">Quantity</th>
                      <th className="px-6 py-4 text-right text-sm font-bold text-slate-900">Total</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {OrderDetails.map((item, index) => (
                      <tr key={index} className="hover:bg-slate-50 transition-colors">
                        <td className="px-6 py-4 text-sm font-semibold text-slate-600">{index + 1}</td>
                        <td className="px-6 py-4 text-sm font-bold text-slate-900">{item.ProductName}</td>
                        <td className="px-6 py-4 text-sm text-slate-600">₹{Number(item.MRP).toFixed(2)}</td>
                        <td className="px-6 py-4 text-sm text-slate-600">₹{Number(item.SaleRate).toFixed(2)}</td>
                        <td className="px-6 py-4 text-sm font-bold text-slate-900">{item.ItemQty}</td>
                        <td className="px-6 py-4 text-sm font-bold text-right text-slate-900">₹{(Number(item.SaleRate) * Number(item.ItemQty)).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="p-12 text-center">
                  <p className="text-slate-500 font-semibold">No items to display</p>
                </div>
              )}
            </div>
          </section>

          {/* Summary & Controls Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Cost Breakdown */}
            <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-md hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
                  <span className="text-slate-700 font-bold">💰</span>
                </div>
                Cost Breakdown
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Subtotal</span>
                  <span className="text-sm font-bold text-slate-900">₹{Number(Grossamt || 0).toFixed(2)}</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Delivery Fees</span>
                  <span className="text-sm font-bold text-slate-900">₹{Number(DeliveryFees || 0).toFixed(2)}</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Discount</span>
                  <span className="text-sm font-bold text-slate-900">-₹{Number(CouponDiscount || 0).toFixed(2)}</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">Wallet Used</span>
                  <span className="text-sm font-bold text-slate-900">-₹{Number(WalletAmount || 0).toFixed(2)}</span>
                </div>
                <div className="mt-4 p-4 bg-slate-900 rounded-lg text-white">
                  <p className="text-xs uppercase tracking-widest opacity-75 mb-1">Final Total</p>
                  <p className="text-2xl font-bold">₹{totalAmount}</p>
                </div>
              </div>
            </section>

            {/* Update Controls */}
            <section className="lg:col-span-2 rounded-2xl border border-slate-200 bg-white p-6 shadow-md hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
                  <span className="text-slate-700 font-bold">⚙️</span>
                </div>
                Update Order
              </h3>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-2">Delivery Date</label>
                  <input
                    type="date"
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent hover:border-slate-400 transition-all"
                    value={deliverydate || formatDateForInput(OrderDeliveryDate)}
                    onChange={(e) => setDeliverydate(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-2">Delivery Time</label>
                  <select
                    value={selectedDeliveryTime || ""}
                    onChange={(e) => setSelectedDeliveryTime(e.target.value)}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent hover:border-slate-400 transition-all"
                  >
                    <option value="">Select Time</option>
                    {deliverytime.map((time) => (
                      <option key={time.id} value={time.id}>{time.time}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-2">Select Driver</label>
                  <select
                    value={selectedDriver || ""}
                    onChange={(e) => setSelectedDriver(e.target.value)}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent hover:border-slate-400 transition-all"
                  >
                    <option value="">Select Driver</option>
                    {drivers.map((driver) => (
                      <option key={driver.Id} value={driver.Id}>
                        {driver.Name} - {driver.Mobile}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-2">Order Status</label>
                  <select
                    value={status || ""}
                    onChange={handleStatusChange}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent hover:border-slate-400 transition-all"
                  >
                    <option value="0">Pending</option>
                    <option value="-1">Cancelled</option>
                    <option value="1">Accepted</option>
                    <option value="2">Delivered</option>
                  </select>
                </div>
              </div>
            </section>
          </div>

          {/* Action Buttons */}
          <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-md">
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={downloadInvoicePDF}
                className="flex-1 px-6 py-3 bg-slate-700 text-white font-bold rounded-lg hover:bg-slate-800 transition-all shadow-sm hover:shadow-md"
              >
                🖨️ Print Invoice
              </button>
              <button
                onClick={handleSave}
                disabled={loading}
                className={`flex-1 px-6 py-3 bg-slate-900 text-white font-bold rounded-lg transition-all shadow-sm hover:shadow-md ${
                  loading
                    ? 'opacity-50 cursor-not-allowed'
                    : 'hover:bg-black'
                }`}
              >
                {loading ? "⏳ Saving..." : "💾 Save Changes"}
              </button>
            </div>
            {errorMessage && (
              <div className="mt-4 p-4 bg-slate-100 border border-slate-300 text-slate-700 rounded-lg text-sm font-bold flex items-center gap-2">
                <span>⚠️</span>
                {errorMessage}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default OrderEdit;
